import { defineComponent, h } from "vue";
import { getSymbolNameParts } from "../../helpers/index.js";
import { symbolImportsDynamic } from "#nuxt-svg-icon-sprite/symbol-import";
import { fallback, svg } from "./shared.js";
const SymbolInline = defineComponent({
  props: {
    name: {
      type: String,
      required: true
    }
  },
  async setup(props) {
    const { symbol } = getSymbolNameParts(props.name);
    const symbolImport = symbolImportsDynamic[props.name];
    if (!symbolImport) {
      return fallback(symbol);
    }
    const result = await symbolImport();
    return svg(symbol, result.attributes, result.content);
  }
});
export default defineComponent({
  props: {
    name: {
      type: String,
      required: true
    }
  },
  setup(props) {
    return () => {
      return h(SymbolInline, { name: props.name, key: props.name });
    };
  }
});
